import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=bd9e033c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd9e033c')) {
      api.createRecord('bd9e033c', component.options)
    } else {
      api.reload('bd9e033c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=bd9e033c&", function () {
      api.rerender('bd9e033c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hWSQS9C6p6bF/JS/comp/ErrorMessage.vue"
export default component.exports